import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import FormStructureContext from '../../context/FormStructureContext';
import { HandleChangeVisible, IFormField } from '../../schema/interface';
import NonDataFieldController from '../NonDataFieldController';
import GroupItem from './GroupItem';

const styles = createUseStyles({
    container: {
        marginTop: '12px',
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'flex-end'
        // padding: '0 20px'
    }
});
interface IGroupOverView {
    field: IFormField;
    uploadMedia: Function;
    handleChangeVisible: HandleChangeVisible;
    noAccess?: boolean;
}
const GroupOverView = ({ field, uploadMedia, handleChangeVisible, noAccess }: IGroupOverView) => {
    const classes = styles();
    const { fetchedFormStructure: formStructure } = useContext(FormStructureContext);

    const childFields = formStructure?.fields?.filter(
        (val: IFormField) =>
            (field.name && val.parent === field.name) ||
            (field.suggested_name && val.parent === field.suggested_name)
    );

    return (
        <div className={classes.container}>
            {childFields
                ?.sort((a: IFormField, b: IFormField) => a.order - b.order)
                ?.filter((field: IFormField) => !field?.presentation?.invisible)
                ?.map((field: IFormField, index: number) => {
                    if (field.data_type === 'none') {
                        return <NonDataFieldController field={field} key={field.name} />;
                    }
                    return (
                        <GroupItem
                            field={field}
                            key={field.name}
                            uploadMedia={uploadMedia}
                            handleChangeVisible={handleChangeVisible}
                            index={index}
                            formStructure={formStructure}
                            noAccess={noAccess}
                        />
                    );
                })}
        </div>
    );
};

export default GroupOverView;
